import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarMessageComponent } from 'src/app/components/snackbar-message/snackbar-message.component';
import { ConfirmComponent } from 'src/app/dialog/confirm/confirm.component';
import { LocalStorage } from 'src/app/enums/local-storage-key.enum';
import { PARAMS } from 'src/app/enums/params.enum';
import { STATUS } from 'src/app/enums/status.enum';
import { SYSTEM } from 'src/app/enums/system.enum';
import { ApiService } from 'src/app/services/api.service';
import { LoadingService } from 'src/app/services/loading.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { UtilityService } from 'src/app/services/utility.service';
import { fadeOp } from 'src/app/util/animations.util';
import { PaymentStatusDialogComponent } from 'src/app/dialog/payment-status-dialog/payment-status-dialog.component';
import { LimitStatusDialogComponent } from 'src/app/dialog/limit-status-dialog/limit-status-dialog.component';
import { Observable } from 'rxjs';
import { TermsDialogComponent } from 'src/app/dialog/terms-dialog/terms-dialog.component';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PAYMENT_STATUS } from 'src/app/enums/payment-status.enum';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { MethodPaymentComponent } from 'src/app/dialog/method-payment/method-payment.component';
import { SafeHtml } from '@angular/platform-browser';
import { BANKS } from 'src/app/enums/bank.enum';
import { TurnstileService } from 'src/app/services/turnstile.service';

declare var AbaPayway: any;
declare const turnstile: any;


export interface ErrorModel {
  location: string
  value: string
  param: string
  msg: string
}

@Component({
  selector: 'app-order-view',
  templateUrl: './order-view.component.html',
  styleUrls: ['./order-view.component.css'],
  animations: [
    fadeOp
  ]
})
export class OrderViewComponent implements OnInit {
  order: any;
  DISPLAY_COLUMN: string[] = ["no", "start_date", "end_date", "national"];
  isPaid: boolean = false;
  countries: any[] = [];
  tickets: any[] = [];
  ticketType: any;
  paymentInfo: any;
  actionUrl: string = '';
  paymentKey: string[] = [];

  payment: { [key: string]: string } = {};
  isKohker: boolean = false;
  isChongKhneas: boolean = false;
  lang: string = '';
  form!: FormGroup;
  isAgree: AbstractControl = new FormControl(false);
  isOneDayType: boolean = true;
  system: string = "";

  isAlertPaymentMessage: boolean = false;
  isConfirmPage: boolean = false;
  isPayment: boolean = false;
  isCheckOut: boolean = false;
  isTodayOrFuture: boolean = false;
  isFuture: boolean = false;
  isInPayment: boolean = false;
  isUnPaid: boolean = false;
  optionPay: any;
  is_check_transaction_pending: boolean = false;

  private orderID!: string;
  private bank: any;

  private params: any;
  html!: SafeHtml;
  banks: any;
  paymentDetail: any;
  private transactionInterval: any;
  readonly PAYMENT_STATUS = PAYMENT_STATUS;
  @ViewChild("mail", { static: false }) mail!: ElementRef;

  @Input() siteKey!: string;
  cfToken: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private snackbar: MatSnackBar,
    private localStorage: LocalStorageService,
    private utility: UtilityService,
    private dialog: MatDialog,
    private loadingService: LoadingService,
    private localStorageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private turnstile: TurnstileService,

  ) {
    this.siteKey = environment.RECAPTCHA_SITEKEY;
    this.preventBackNavigation();
    this.init();
  }

  ngOnInit(): void {
    if (this.lang == '') {
      this.lang = this.localStorageService.get(LocalStorage.LANG);
    }

    this.form = this.formBuilder.group({
      isAgree: [false],
    });

    this.isAgree = this.form.get('isAgree')!;
  }

  init(): void {
    this.loadingService._setLoading();
    this.params = this.route.snapshot.queryParams;
    if (!this.params && !this.params.id) {
      this.router.navigateByUrl("order");
      return;
    }
    this.orderID = this.params.id;
    this.getBanks();
    this.getOrder();
  }

  reCAPTCHA(): Promise<string> {
    return new Promise((resolve, reject) => {

      if (!turnstile) {
        reject('Turnstile not loaded');
        return;
      }

      const widget = document.getElementById('turnstile-widget');
      if (!widget) {
        reject('Turnstile widget not found');
        return;
      }

      widget.innerHTML = '';

      const widgetId = turnstile.render(widget, {
        sitekey: this.siteKey,
        size: 'invisible',
        action: 'payment_order_id',

        callback: (token: string) => {
          this.cfToken = token;
          resolve(token);
        },

        'error-callback': (err: any) => {
          turnstile.reset(widgetId);
          reject(err);
        },

        'expired-callback': () => {
          turnstile.reset(widgetId);
          reject('Token expired');
        }
      });

      turnstile.execute(widgetId);
    });
  }


  @HostListener("window:popstate", ["$event"])
  onPopState(event: PopStateEvent) {
    const isOrderPage = this.router.url.startsWith("/order/");

    if (isOrderPage) {
      if (this.isPayment) {
        // Show confirmation before leaving
        const confirmExit = confirm("Are you sure you want to leave this page?");

        if (!confirmExit) {
          this.preventBackNavigation();
          return;
        } else {
          this.handleRollback();

          return;
        }
      }
      window.location.replace('/order');
      // history.back();
    }
  }

  preventBackNavigation() {
    history.pushState(null, "", this.router.url);
  }

  _handleCheckTransaction(): void {
    if (!this.order?._id) {
      console.warn('Order ID missing, cannot check transaction.');
      return;
    }

    this.api.checkTransaction({ order_id: this.order._id, is_local: 1 })
      .subscribe({
        next: (response) => {
          if (response.status != STATUS.SUCCESS) {
            console.warn('Transaction check returned non-success status', response);
            return;
          }

          if (!response.data || !response.data.status) {
            console.warn('Invalid payment response', response);
            return;
          }

          const status = response.data.status;

          // If payment succeeded or failed
          if (status === PAYMENT_STATUS.SUCCESS || status === PAYMENT_STATUS.FAILED) {
            const isSuccess = status === PAYMENT_STATUS.SUCCESS;

            if (isSuccess) {
              this.router.navigate(['/order', 'view'], {
                queryParams: { id: this.orderID, payment: '1' }
              });
              this.getOrder();
              this._handlePaymentStatusDialogComponent();
            }

            this.clearTransactionInterval();
          }
        },
        error: (err) => {
          if (err.status === 0) {
            console.error('Network or CORS error when checking transaction', err);
          } else {
            console.error(`HTTP error ${err.status}: ${err.message}`, err);
          }
        }
      });
  }

  clearTransactionInterval() {
    if (this.transactionInterval) {
      clearInterval(this.transactionInterval);
      this.transactionInterval = null;
    }
  }


  _handlePaymentStatusDialogComponent(): void {
    this.dialog.open(PaymentStatusDialogComponent, {
      width: '450px',
      autoFocus: false,
      disableClose: true,
      role: 'alertdialog',
      data: {
        title: "TITLE.PAYMENT_STATUS",
        texts: ['MSG.PAYMENT_STATUS.PAY'],
        pay: true,
        order_id: this.order._id,
        order_tx_number: this.order?.order_tx_number
      }
    });
  }


  handleRollback() {
    setTimeout(() => {
      // this.router.navigateByUrl('/order').then(() => {
      window.location.replace('/order');
      // });
    }, 100);
  }

  getOrder(): void {
    this.loadingService._setLoading();
    this.api.getOrderById(this.orderID)
      .subscribe({
        next: response => {
          if (response.status != STATUS.SUCCESS) {
            this.openErrorMessage('MSG.ORDER_NOT_FOUND');
            this.router.navigateByUrl('/order');
            return;
          }
          this.order = response.data.order;
          this.ticketType = this.order?.tickets[0].tickets[0].ticket.ticket_type;
          this.tickets = this.order.tickets.flatMap((t: any) => t.tickets);
          // const ticket = this.tickets[0].ticket;
          const ticketStartDate = moment.tz(this.tickets[0].ticket.start_date, 'Asia/Phnom_Penh');
          const today = moment().tz('Asia/Phnom_Penh').startOf('day');
          this.isTodayOrFuture = ticketStartDate.isSameOrAfter(today, 'day');
          this.isFuture = ticketStartDate.isAfter(today, 'day');

          this.system = this.order.system;
          this.system = this.order.system;

          this.getNationalities();
          this.isKohker = this.order.system == SYSTEM.KOHKER;
          this.isChongKhneas = this.order.system == SYSTEM.CHONGKHNEAS;
          this.isPaid = this.order.status === PAYMENT_STATUS.PAID;
          this.isInPayment = this.order.status === PAYMENT_STATUS.IN_PAYMENT;
          this.isUnPaid = this.order.status === PAYMENT_STATUS.UNPAID;
          this.isOneDayType = this.ticketType?.num_day == 1 ? true : false;

          let isPay = this.params.payment == '1';

          // if (isPay && this.order.status === PAYMENT_STATUS.PAID) {
          //      this.router.navigate(['/order', 'view'], { queryParams: { id: this.orderID, payment: '1' } });
          //      this._handlePaymentStatusDialogComponent();
          //      this.localStorage.delete(LocalStorage.his_status);
          // }
          if (!this.isPaid) this.localStorage.set(LocalStorage.his_status, this.order.status);
          if (!this.isKohker && !this.isChongKhneas && !this.isOneDayType && !this.DISPLAY_COLUMN.includes('image')) {
            this.DISPLAY_COLUMN.splice(1, 0, 'image');
          }

          if (!(isPay || this.order?.order_tx_number) && (this.isInPayment || this.isUnPaid)) {
            this._handleCheckTransaction();
            this.transactionInterval = setInterval(() => {
              this._handleCheckTransaction();
            }, 3000);
          }

        },
        error: () => {
          this.openErrorMessage('MSG.SOMETHINK_WENT_WRONG');
        },
        complete: () => {
          this.loadingService._clearLoading();
          // ALERT REDIRECT FROM PAYMENT {{ START }}
          if (this.params.hasOwnProperty('payment') && !this.isAlertPaymentMessage) {
            this.getOrder();
            this.isAlertPaymentMessage = true;
            let isPay = this.params.payment == '1';

            if (isPay) {
              this.dialog.closeAll()
            }
            this.dialog.open(PaymentStatusDialogComponent, {
              width: '450px',
              autoFocus: false,
              disableClose: true,
              role: 'alertdialog',
              data: {
                title: "TITLE.PAYMENT_STATUS",
                texts: [isPay ? 'MSG.PAYMENT_STATUS.PAY' : 'MSG.PAYMENT_STATUS.UNPAY'],
                pay: isPay,
                order_id: this.order._id,
                order_tx_number: this.order.order_tx_number
              }
            })

            // .afterClosed().subscribe(res=> {
            //   this.router.navigateByUrl(`/order/view?id=${this.orderID}`);
            //   this.getOrder();
            // })
          }
        }
      })
  }
  downloadReceipt(): void {
    this.loadingService._setLoading();
    this.api.downloadOrderReciept(this.order._id)
      .subscribe({
        next: response => {
          if (!response) return;
          this.saveFile(response, this.order.order_tx_number + '-receipt', 'pdf');
        },
        error: () => {
          this.loadingService._clearLoading();
        },
        complete: () => {
          this.loadingService._clearLoading();
        }
      })
  }
  downloadTickets(): void {
    this.loadingService._setLoading();
    this.api.downloadOrderTickets(this.order._id)
      .subscribe({
        next: response => {
          if (!response || response.constructor != Blob) {
            return;
          }
          this.saveFile(response, this.order.order_tx_number + '-ticket', 'pdf');
          this.loadingService._clearLoading();
        },
        error: () => {
          this.loadingService._clearLoading();
        },
        complete: () => {
          this.loadingService._clearLoading();
        }
      })
  }

  saveFile(blob: Blob, filename: string, ext?: string): void {
    const downloader = document.createElement('a');
    const url = URL.createObjectURL(blob);
    downloader.href = url;
    downloader.download = filename + (ext ? '.' + ext : '');
    downloader.click();
    URL.revokeObjectURL(url);
    downloader.remove();
  }
  get currentLang(): string {
    return this.utility.getLang();
  }

  async onCheckout(): Promise<void> {
    this.loadingService._setLoading();
    try {
      await this.reCAPTCHA();

    } catch (error) {
      console.error('Turnstile error:', error);
      return;

    }
    this.api.submitOrder(this.order._id, this.system)
      .subscribe({
        next: response => {
          switch (response.status) {
            case STATUS.ERROR_OTHER:
              this.dialog.open(LimitStatusDialogComponent, {
                width: '450px',
                autoFocus: false,
                disableClose: true,
                data: {
                  title: 'TITLE.SUBMIT_LIMIT',
                  messages: response.message
                },
              });
              break;
            case STATUS.ERROR_CLIENT:
              switch (response.errors[0].param) {
                case PARAMS.START_DATE:
                  this.openInvalidDialog('MSG.DAY_INCORRECT');
                  break;
                default:
                  this.openInvalidDialog('MSG.CHECK_CORRECT');
                  break;
              }
              break;
            case STATUS.SUCCESS:
              this.methodPayment();
          }
        },
        error: _error => {
          this.openErrorMessage("MSG.SOMETHINK_WENT_WRONG");
        },
        complete: () => {
          this.loadingService._clearLoading();
        }
      });
  }


  methodPayment(): void {
    this.loadingService._setLoading();
    this.dialog.open(MethodPaymentComponent, {
      width: '100%',
      maxWidth: '550px',
      panelClass: 'custom-dialog-container',
      disableClose: true,
      autoFocus: false,
      data: {
        _id: this.order._id,
        banks: this.banks
      }
    }).afterClosed()
      .subscribe(result => {
        if (!result.data) return;
        this.bank = result?.data;
        this.getPaymentData()
          .subscribe(() => {
            this.loadingService._clearLoading();
            setTimeout(() => {
              switch (this.paymentDetail?.bank) {
                case BANKS.ABA:
                  try {
                    document.forms.namedItem('aba_merchant_request')?.submit();
                  } catch (err) {
                    console.error('ABA checkout error:', err);
                  }
                  break;

                case BANKS.ACLEDA:
                  try {
                    document.forms.namedItem('_xpayTestForm')?.submit();
                  } catch (err) {
                    console.error('ACLEDA checkout error:', err);
                  }
                  break;

                default:
                  console.warn('Unsupported bank:', this.bank);
              }
            }, 500);
          });
      });
  }

  getPaymentData(): Observable<void> {
    this.loadingService._setLoading();
    localStorage.setItem('current_tab_id', this.router.url);
    const payload: any = {
      client_type: 'web',
      order_id: this.order._id,
      payment_option: this.bank?.payment_option,
      recaptchaToken: this.cfToken
    };

    if (!((this.bank?.code === BANKS.ABA || this.bank?.code === 'other') && this.bank?.payment_option === BANKS.CARD)) {
      payload.bank_name = this.bank?.code;
    }

    return new Observable((subscriber => {
      this.loadingService._setLoading();
      this.api.paymentDataV3(payload)
        .subscribe({
          next: async (response) => {
            if (response.status == STATUS.ERROR_ORDER_EXIST) {
              this.dialog.open(PaymentStatusDialogComponent, {
                width: '450px',
                autoFocus: false,
                disableClose: true,
                role: 'alertdialog',
                data: {
                  title: "TITLE.PAYMENT_STATUS",
                  texts: ['MSG.PAYMENT_STATUS.PAY'],
                  pay: true,
                  order_id: this.order._id,
                  order_tx_number: this.order.order_tx_number
                }
              }).afterClosed()
                .subscribe(() => {
                  this.getOrder()
                });
              return;
            }
            else if (response.status == STATUS.ERROR_CLIENT && [STATUS.reCAPTCHA_EXPIRED, STATUS.INVALID_TOKEN, STATUS.MISSING_reCAPTCHA, STATUS.SERVER_ERROR].includes(response.code)) {
              await this.reCAPTCHA();

            }
            else if (response.status === STATUS.ERROR_SERVER) {
              this.openErrorMessage("MSG.SOMETHINK_WENT_WRONG");
              return;
            }
            else if (response.status !== STATUS.SUCCESS) {
              this.openErrorMessage(response.errors?.[0]?.msg);
              subscriber.error(response);
              return;
            }
            this.paymentDetail = response.data;
            this.payment = response.data?.payment;
            this.paymentInfo = Object.assign({}, this.payment);
            this.actionUrl = this.payment?.actionUrl || '';

            this.paymentKey = Object.keys(this.paymentInfo);

            if (this.paymentKey.indexOf('paymentCard') >= 0) {
              this.paymentKey.splice(this.paymentKey.indexOf('paymentCard'), 1);
            }

            if (this.paymentKey.indexOf('operationType') >= 0) {
              this.paymentKey.splice(this.paymentKey.indexOf('operationType'), 1);
            }

            if (this.paymentKey.indexOf('actionUrl') >= 0) {
              this.paymentKey.splice(this.paymentKey.indexOf('actionUrl'), 1);
            }

            this.localStorage.set(LocalStorage.PAY_ORDER, this.order._id);
            subscriber.next();
          },
          error: _error => {
            subscriber.error("faild");
            this.openErrorMessage("MSG.SOMETHINK_WENT_WRONG");
          },
          complete: () => {
            subscriber.complete();
            this.loadingService._clearLoading();
          }
        });
      // })
    }))
  }

  getBanks() {
    this.api.getBanks()
      .subscribe({
        next: (res) => {
          if (res?.status === STATUS.SUCCESS) {
            this.banks = res?.data ?? [];
          }
        },
        error: (err) => {
          console.log('Error fetching banks', err);
        }
      })
  }

  onAgree() {
    this.dialog.open(TermsDialogComponent, {
      width: '950px',
      disableClose: true,
      autoFocus: false,
      data: {
        type: 'payment',
        // term_and_con: this.term_condition
      }
    })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.isAgree.setValue(true);
          this.loadingService.setLoading(false);
        }
      })
  }

  onDelete(): void {
    this.dialog.open(ConfirmComponent, {
      width: '450px',
      disableClose: true,
      data: {
        translate: {
          title: "TITLE.DELETE_ORDER",
          descriptions: ["MSG.DELETE_ORDER"],
          isDelete: true
        }
      }
    })
      .afterClosed()
      .subscribe(response => {
        if (!response) return;
        this.loadingService._setLoading();
        this.api.deleteUnpaidOrder(this.order._id)
          .subscribe({
            next: response => {
              if (response.status != STATUS.SUCCESS) {
                this.openErrorMessage('MSG.DELETE_FAILED');
                return;
              }
              this.router.navigateByUrl("/order");
            },
            error: () => {
              this.openErrorMessage("MSG.SOMTHINK_WENT_WRONG");
            },
            complete: () => {
              this.loadingService._clearLoading;
            }
          })
      })
  }
  openInvalidDialog(message: string): void {
    this.dialog.open<ConfirmComponent>(ConfirmComponent, {
      width: '450px',
      data: {
        isError: true,
        translate: {
          title: 'TITLE.INVALID_SUBMIT',
          descriptions: [message, "CONFIRM.EDIT_ORDER"],
          postive: 'LABEL.OK',
          negative: 'LABEL.NO'
        }
      }
    })
      .afterClosed()
      .subscribe(
        response => {
          if (!response) return;
          this.router.navigate(['/order', 'edit'], { queryParams: { id: this.order._id } });
        }
      )
  }
  openErrorMessage(message: string): void {
    this.snackbar.openFromComponent(SnackbarMessageComponent, {
      data: {
        message
      },
      panelClass: 'bg-warn',
      duration: 2000
    });
  }

  goBack(): void {
    this.router.navigate(['/order']);
  }

  reSubmit() {
    this.dialog.open(ConfirmComponent, {
      width: '450px',
      data: {
        translate: {
          title: "TITLE.RE_SUBMIT_ORDER",
          descriptions: ["MSG.RE_SUBMIT_ORDER"]
        }
      }
    }).afterClosed().subscribe(response => {
      if (!response) return;
      this.loadingService._setLoading();
      this.api.reSubmitOrder(this.order._id).subscribe({
        next: response => {
          if (response.status != STATUS.SUCCESS) {
            this.openErrorMessage("MSG.RE_SUBMIT_FAILED");
            return;
          }
          this.init()
          this.snackbar.openFromComponent(SnackbarMessageComponent, {
            data: {
              message: "MSG.RE_SUBMIT_SUCCESS"
            },
            panelClass: 'bg-accent',
            duration: 2000
          });
        },
        error: () => {
          this.openErrorMessage("MSG.SOMTHINK_WENT_WRONG");
        },
        complete: () => {
          this.loadingService._clearLoading();
        }
      })
    })
  }

  getNationalities(): void {
    this.api.getNationalities({ system: this.system })
      .subscribe(response => {
        this.countries = response.data;
      });
  }

  getNationalityByID(id: string) {
    let nationality = this.countries?.find(country => country._id == id);
    let name;
    switch (this.lang) {
      case 'kr':
        name = nationality?.name.kr;
        break;
      case 'ch':
        name = nationality?.name.ch;
        break;
      case 'jp':
        name = nationality?.name.jp;
        break;

      default:
        name = nationality?.name.en;
        break;
    }
    return name;
  }


  // getNationalityByID(id: string): Nationality {
  //   return this.countries?.find(country => country._id == id) || {} as Nationality;
  // }

  setDateFormat(date: any) {
    return this.utility.setDate_dd_MMM_YYYY(date)
  }

  ngOnDestroy() {
    this.clearTransactionInterval();
  }
}

